/**
 * Contributing Translations Module (French)
 * 
 * @module contributing
 * @language fr
 */

export const contributing = {
  contributing: {
    // Hero Section
    pageTitle: "Contribuer à Youth Futures",
    heroSubtitle: "Une initiative de recherche collaborative dédiée à comprendre et faire avancer le leadership jeune à l'échelle mondiale",
    heroDescription: "Nous invitons les institutions, organisations, chercheurs, membres et partenaires communautaires à contribuer des données, insights et expertise qui renforcent notre plateforme.",
    
    // Why Contribute Section
    whyContributeTitle: "Pourquoi Contribuer ?",
    whyContributeSubtitle: "Votre contribution fait une vraie différence dans la compréhension du leadership jeune mondial",
    
    globalImpact: "Impact Mondial",
    globalImpactDesc: "Vos données atteignent les décideurs politiques, investisseurs, membres JCI du monde entier et la communauté mondiale du leadership jeune—créant un impact tangible sur la façon dont les jeunes leaders sont développés et reconnus.",
    
    academicRecognition: "Reconnaissance Académique",
    academicRecognitionDesc: "Citation formelle dans les rapports techniques, publications scientifiques, présentations aux congrès internationaux, certificats de collaboration et reconnaissance sur les réseaux sociaux—valide pour le CV académique et les portfolios professionnels.",
    
    rigorousMethodology: "Méthodologie Rigoureuse",
    rigorousMethodologyDesc: "Toutes les contributions suivent les standards internationaux (directives de l'ONU, meilleures pratiques académiques) garantissant une crédibilité maximale pour votre institution et vos résultats.",
    
    openAccess: "Accès Ouvert",
    openAccessDesc: "Toutes les découvertes sont disponibles publiquement via des tableaux de bord interactifs, rapports techniques (PDF), fichiers de données (CSV/Excel), sous licence Creative Commons—gratuit pour un usage non commercial.",
    
    formalRecognition: "Reconnaissance Formelle",
    formalRecognitionDesc: "Citation dans les rapports techniques et présentations, mention dans les congrès et événements internationaux, certificat numérique de collaboration, reconnaissance sur les réseaux sociaux JCI, valide pour les références professionnelles.",
    
    // Who Can Contribute Section
    whoCanContributeTitle: "Qui Peut Contribuer ?",
    whoCanContributeSubtitle: "Des perspectives diverses renforcent notre plateforme de recherche",
    
    nationalOrgs: "Organisations Nationales JCI",
    nationalOrgsDesc: "Partagez des données stratégiques sur le développement du leadership, l'engagement des membres, l'impact des programmes et les initiatives régionales.",
    nationalOrgsDetails: "Statistiques et démographie des membres nationaux, résultats de programmes et projets alignés sur le Plan Stratégique JCI 2023-2027, tendances et insights de leadership régional, résultats de partenariats et collaborations, métriques de formation et développement, données de participation aux événements, initiatives stratégiques et innovations.",
    nationalOrgsWhy: "Aidez l'Observatoire à refléter la vraie diversité et l'impact de JCI dans toutes les régions et pays.",
    
    committees: "Comités et Conseils JCI",
    committeesDesc: "Les comités spécialisés contribuent leur expertise sur des dimensions spécifiques du développement du leadership.",
    committeesDetails: "Conseils de Développement (Stratégique, Opérationnel, Éducatif, Impact), données et métriques spécifiques aux conseils, meilleures pratiques et méthodologies, résultats de développement des membres, résultats de formation et certification, indicateurs de performance régionale.",
    committeesWhy: "Permettez à l'Observatoire de présenter des perspectives spécialisées sur la façon dont JCI développe les leaders dans toutes les dimensions stratégiques.",
    
    individualMembers: "Membres Individuels JCI",
    individualMembersDesc: "Chaque membre a des insights et expériences précieux à partager.",
    individualMembersDetails: "Histoires personnelles de développement du leadership, retours et résultats de participation aux programmes, expériences de développement de compétences et formation, insights de mentorat et réseautage, exemples d'avancement de carrière, projets d'impact communautaire, corrections et mises à jour de qualité des données, suggestions méthodologiques et retours.",
    individualMembersWhy: "Les voix des membres garantissent que l'Observatoire reflète les vrais parcours de leadership et expériences vécues au sein de JCI.",
    
    researchPartners: "Partenaires de Recherche et Institutions Académiques",
    researchPartnersDesc: "Les universités, centres de recherche et groupes académiques contribuent de la recherche et analyse originale.",
    researchPartnersDetails: "Articles de recherche académique et études, études longitudinales sur le développement des membres JCI, analyse comparative avec d'autres organisations de leadership, révisions et validations méthodologiques, projets de recherche étudiants, cartographie et analyse institutionnelle, études d'alignement curriculaire, ensembles de données et découvertes publiées.",
    researchPartnersWhy: "Les partenariats académiques valident l'Observatoire comme une plateforme de recherche crédible alignée sur les standards internationaux.",
    
    educationalInstitutions: "Institutions Éducatives et Centres de Formation",
    educationalInstitutionsDesc: "Les écoles, universités, centres de formation professionnelle contribuent des données éducatives.",
    educationalInstitutionsDetails: "Cartographie du curriculum de leadership, inscription et résultats des étudiants membres JCI, résultats des programmes de formation, métriques de développement des compétences, données d'emploi des diplômés, résultats des programmes de partenariat, alignement des cours avec le cadre JCI, données de certification et accréditations.",
    educationalInstitutionsWhy: "Les données éducatives révèlent comment le développement du leadership JCI se traduit en avancement académique et professionnel.",
    
    governmentNgos: "Gouvernement, ONGs et Partenaires Institutionnels",
    governmentNgosDesc: "Les agences gouvernementales, organisations internationales et partenaires de la société civile contribuent des données stratégiques.",
    governmentNgosDetails: "Alignement des politiques publiques avec les initiatives JCI, résultats des partenariats gouvernementaux, données de collaboration avec les organisations internationales, efficacité des partenariats avec les ONGs, métriques d'impact communautaire, données de durabilité et responsabilité sociale, reconnaissance et approbations institutionnelles, alignement réglementaire et des cadres.",
    governmentNgosWhy: "Les partenariats institutionnels démontrent la crédibilité de JCI et l'alignement avec les agendas de développement mondial.",
    
    // How to Contribute Section
    howToContributeTitle: "Comment Contribuer",
    howToContributeSubtitle: "Soumettez votre contribution par email avec les informations requises",
    
    contributionFormTitle: "Formulaire de Contribution",
    contributionFormDesc: "Soumettez votre contribution en utilisant notre formulaire. Tous les champs sont obligatoires.",
    sendTo: "Les informations seront envoyées à :",
    
    yourInformation: "Vos Informations",
    fullName: "Nom Complet",
    fullNameDesc: "Votre nom complet",
    affiliatedOrg: "Organisation Affiliée",
    affiliatedOrgDesc: "Organisation Nationale, Comité, Institution, Entreprise, etc.",
    emailAddress: "Adresse Email",
    emailAddressDesc: "Où nous vous contacterons",
    yourRole: "Votre Rôle",
    yourRoleDesc: "Position/fonction dans votre organisation",
    
    contributionDetails: "Détails de la Contribution",
    contributionType: "Type de Contribution",
    contributionTypeDesc: "Sélectionnez la catégorie : Données de Recherche, Résultats de Programme, Insights de Membres, Partenariat Institutionnel, Résultats de Formation, Analyse Stratégique, Amélioration de la Qualité, Autre",
    contributionDescription: "Description de la Contribution",
    contributionDescriptionDesc: "Décrivez brièvement ce que vous offrez et pourquoi c'est pertinent (minimum 20 caractères)",
    dataFormat: "Format des Données",
    dataFormatDesc: "Comment les données sont-elles disponibles ? (Excel, PDF, Article scientifique, Lien, Base de données, Rapport, Autre)",
    dataScope: "Portée des Données",
    dataScopeDesc: "Portée géographique et période couverte",
    verificationStatus: "Statut de Vérification",
    verificationStatusDesc: "Ces données sont-elles vérifiées/auditables ? Oui / Non",
    
    authorization: "Autorisation et Engagement",
    citationAuth: "J'autorise l'utilisation des données fournies dans l'Observatoire JCI, avec attribution formelle de la source dans tous les matériaux publiés",
    dataOwnership: "Je confirme que mon organisation possède ou a la permission de partager ces données",
    accuracy: "Je certifie que les données fournies sont exactes et représentent les meilleures informations disponibles",
    required: "Obligatoire",
    
    // Contribution Process Section
    processTitle: "Processus de Contribution",
    processSubtitle: "De la soumission à la publication en 2-4 semaines",
    
    step1: "Contact et Soumission",
    step1Desc: "Soumettez votre proposition par email avec le formulaire complété",
    step2: "Révision Initiale",
    step2Desc: "Notre équipe évalue la pertinence, la qualité et l'alignement avec les valeurs et la méthodologie JCI",
    step3: "Vérification des Données",
    step3Desc: "Nous vérifions les sources de données, les méthodologies et la précision avant l'intégration",
    step4: "Intégration",
    step4Desc: "Les données et insights sont intégrés à la plateforme de l'Observatoire",
    step5: "Reconnaissance Formelle",
    step5Desc: "Votre contribution reçoit une citation formelle, un certificat et une reconnaissance publique",
    
    timeline: "Délai : 2-4 semaines de la soumission à la publication",
    
    // Our Commitments Section
    commitmentsTitle: "Nos Engagements",
    commitmentsSubtitle: "Ce que nous promettons à chaque contributeur",
    
    transparencyProtocol: "Protocole de Transparence",
    transparencyProtocolDesc: "Nous maintenons une transparence totale dans toutes les contributions : toutes les sources citées avec crédits complets, noms des organisations et contributeurs clairement identifiés, titre du travail/ensemble de données et date de publication documentés, lien complet et DOI si disponible, références bibliographiques complètes, méthodologie et formules de calcul expliquées, limitations des données clairement indiquées. Chaque contribution est traçable et vérifiable.",
    
    openMethodology: "Méthodologie Ouverte",
    openMethodologyDesc: "L'Observatoire fonctionne avec une transparence méthodologique totale : tous les cadres et indicateurs documentés, méthodologies de calcul entièrement expliquées, disponible pour audit académique public, rapports techniques avec détails complets, feuilles de calcul avec toutes les formules, FAQ répondant aux questions méthodologiques, révisions et mises à jour méthodologiques régulières. Vous pouvez vérifier tout ce que nous publions.",
    
    formalRecognitionCommitment: "Reconnaissance Formelle",
    formalRecognitionCommitmentDesc: "Les contributeurs reçoivent une reconnaissance complète : citation dans tous les rapports techniques et publications, mention dans les présentations aux congrès internationaux JCI, certificat numérique de collaboration (téléchargeable), reconnaissance sur les réseaux sociaux JCI, mise en avant dans la section \"Contributeurs\" de l'Observatoire, invitation à co-écrire des études spéciales, accès prioritaire aux nouveaux ensembles de données de l'Observatoire. Votre contribution renforce la crédibilité de votre institution.",
    
    publicAccess: "Accès Public",
    publicAccessDesc: "Toutes les données et insights de l'Observatoire sont disponibles gratuitement : tableau de bord en ligne interactif, rapports techniques au format PDF, fichiers de données au format CSV/Excel, Licence Creative Commons BY-NC-SA 4.0, gratuit pour usage académique non commercial, licence commerciale disponible sur demande, accès API pour les partenaires de recherche enregistrés. Vos insights atteignent une audience mondiale.",
    
    dataQualityStandards: "Standards de Qualité des Données",
    dataQualityStandardsDesc: "Nous maintenons des pratiques rigoureuses de qualité des données : toutes les données doivent être vérifiées et auditables, pas de données synthétiques ou estimées sans notation claire, les sources doivent être publiquement documentées, la méthodologie doit être reproductible, précision des données vérifiée avant publication, audits et révisions de qualité réguliers, procédures de correction pour les erreurs. L'excellence est non négociable.",
    
    // Contribution Types Section
    contributionTypesTitle: "Types de Contribution et Exemples",
    contributionTypesSubtitle: "Différentes façons de contribuer à l'Observatoire",
    
    researchData: "Données de Recherche",
    researchDataExamples: "Articles de recherche académique sur le leadership jeune, études longitudinales sur le développement des membres, analyses comparatives avec des organisations pairs, résultats d'enquêtes et analyses statistiques",
    
    programResults: "Résultats de Programmes",
    programResultsExamples: "Métriques de résultats des programmes JCI, évaluations d'impact de projets, données de complétion de formation et certification, statistiques d'engagement et rétention des membres",
    
    memberInsights: "Insights de Membres",
    memberInsightsExamples: "Données démographiques des membres, exemples d'avancement de carrière, histoires de développement des compétences de leadership, résultats des programmes de mentorat",
    
    institutionalPartnerships: "Partenariats Institutionnels",
    institutionalPartnershipsExamples: "Données d'efficacité des partenariats, résultats de collaborations, résultats de programmes conjoints, approbations institutionnelles",
    
    trainingOutcomes: "Résultats de Formation",
    trainingOutcomesExamples: "Métriques des programmes de formation, données de certification, évaluations de développement des compétences, analyses d'alignement éducatif",
    
    strategicAnalysis: "Analyse Stratégique",
    strategicAnalysisExamples: "Tendances et insights régionaux, analyses sectorielles spécifiques, documentation des meilleures pratiques, études de cas d'innovation",
    
    qualityImprovements: "Améliorations de la Qualité",
    qualityImprovementsExamples: "Corrections et mises à jour de données, suggestions méthodologiques, identification d'informations manquantes, recommandations d'amélioration des processus",
    
    // Data Requirements Section
    dataRequirementsTitle: "Exigences de Données",
    dataRequirementsSubtitle: "Pour que les contributions soient acceptées, assurez-vous de :",
    
    mandatoryElements: "Éléments Obligatoires",
    mandatoryList: "Identification claire de la source des données, période couverte (plage de dates), portée géographique (régionale, nationale, mondiale), méthodologie de collecte des données, taille de l'échantillon (si applicable), déclaration de vérification, déclaration de permission de partage",
    
    recommendedElements: "Éléments Recommandés",
    recommendedList: "Personne de contact pour questions, documentation de support, études ou références liées, limitations ou mises en garde, usage/interprétation suggérés, ensembles de données liés pour référence croisée, fréquence de mise à jour (si récurrent)",
    
    // FAQ Section
    faqTitle: "Questions Fréquemment Posées",
    faqSubtitle: "Questions courantes sur la contribution à l'Observatoire",
    
    faq1Q: "Combien de temps prend le processus de contribution ?",
    faq1A: "Typiquement 2-4 semaines de la soumission à la publication, selon la complexité des données et les étapes de vérification requises.",
    
    faq2Q: "Mon organisation sera-t-elle créditée ?",
    faq2A: "Oui, absolument. Toutes les contributions reçoivent une citation formelle dans chaque publication où elles apparaissent.",
    
    faq3Q: "Pouvons-nous contribuer des données confidentielles ?",
    faq3A: "Généralement non—l'Observatoire nécessite des données publiques et vérifiables. Cependant, des données agrégées ou anonymisées peuvent être possibles. Contactez-nous pour discuter de situations spécifiques.",
    
    faq4Q: "Devons-nous contribuer des données pour utiliser l'Observatoire ?",
    faq4A: "Non. L'Observatoire est gratuit et ouvert à tous. Les contributions sont volontaires et appréciées, mais pas obligatoires.",
    
    faq5Q: "Que se passe-t-il si nous trouvons une erreur dans nos données ?",
    faq5A: "Nous avons une procédure de correction. Contactez-nous immédiatement et nous mettrons à jour les données et publierons un avis d'erratum.",
    
    faq6Q: "Les contributions peuvent-elles être mises à jour ?",
    faq6A: "Oui. Les mises à jour annuelles sont encouragées. Soumettez des données mises à jour à tout moment avec un historique de version clair.",
    
    faq7Q: "Y a-t-il un coût pour contribuer ?",
    faq7A: "Non. Les contributions sont volontaires. Nous valorisons votre expertise et vos insights.",
    
    // Team & Contact Section
    teamTitle: "Notre Équipe",
    teamSubtitle: "Contactez-nous pour commencer votre parcours de contribution",
    
    observatoryTeam: "Équipe de l'Observatoire JCI",
    dashcityTeam: "Équipe Dashcity",
    email: "Email",
    website: "Site Web",
    contactForm: "Formulaire de Contact",
    
    developmentCouncils: "Coordination des Conseils de Développement",
    strategicCouncil: "Conseil de Développement Stratégique",
    operationalCouncil: "Conseil de Développement Opérationnel",
    educationalCouncil: "Conseil de Développement Éducatif",
    impactCouncil: "Conseil de Développement d'Impact",
    
    // Our Commitments to You Section
    partnershipTitle: "Nos Engagements envers Vous",
    partnershipSubtitle: "Quand vous contribuez à l'Observatoire JCI, vous vous associez avec :",
    
    commitment1: "Une organisation mondiale de leadership jeune avec 100+ ans d'histoire et une présence dans 120 pays",
    commitment2: "Une institution axée sur les données alignée sur les Objectifs de Développement Durable de l'ONU et les meilleures pratiques internationales",
    commitment3: "Une plateforme de recherche crédible construite sur une méthodologie rigoureuse et des processus transparents",
    commitment4: "Une communauté inclusive qui valorise les perspectives et voix diverses",
    commitment5: "Un mouvement croissant transformant la façon dont les jeunes leaders sont développés et reconnus",
    
    // Why Your Data Matters Section
    whyDataMattersTitle: "Pourquoi Vos Données Comptent",
    whyDataMattersSubtitle: "L'Observatoire JCI existe pour répondre à des questions critiques :",
    
    question1: "Comment les jeunes leaders sont-ils développés à l'échelle mondiale ?",
    question2: "Quelles compétences comptent le plus pour les futurs leaders ?",
    question3: "Comment JCI transforme-t-elle la vie des membres ?",
    question4: "Qu'est-ce qui crée un impact de leadership durable ?",
    question5: "Comment le mentorat, la formation et la communauté façonnent-ils les leaders ?",
    
    dataMattersConclusion: "Votre contribution aide à répondre à ces questions avec des données réelles, des expériences réelles et un impact réel. Ensemble, nous construisons la plateforme de référence pour comprendre le développement du leadership jeune.",
    
    // CTA Section
    ctaTitle: "Prêt à Contribuer ?",
    ctaSubtitle: "Trois Étapes Simples",
    
    ctaStep1: "Remplissez le formulaire avec les détails de votre contribution",
    ctaStep2: "Envoyez à tmariano@jci.cc avec tous les fichiers de support",
    ctaStep3: "Attendez la confirmation - notre équipe vous contactera sous 5 jours ouvrables",
    
    questionsTitle: "Des Questions Avant de Commencer ?",
    questionsContact: "Envoyez-nous un email à : observatory@jci.cc",
    questionsAlternative: "Ou contactez votre représentant régional du Conseil de Développement via votre Organisation Nationale.",
    
    startContributing: "Commencer à Contribuer",
    contactUs: "Nous Contacter",
    
    // Checklist
    checklistTitle: "Liste de Vérification de Contribution",
    checklistSubtitle: "Avant de soumettre, vérifiez que vous avez :",
    
    checkItem1: "Informations complètes du contributeur",
    checkItem2: "Type de contribution clairement sélectionné",
    checkItem3: "Documentation de la source des données",
    checkItem4: "Période et portée géographique définies",
    checkItem5: "Déclaration de vérification/audit",
    checkItem6: "Autorisation de partager",
    checkItem7: "Fichiers de support prêts",
    checkItem8: "Informations de contact pour suivi",
    
    // Footer info
    lastUpdated: "Dernière Mise à Jour : Décembre 2025",
    availableLanguages: "Disponible en Anglais, Portugais, Espagnol, Français et Japonais",
    joinCommunity: "Rejoignez la communauté de contributeurs qui construit l'avenir de la recherche sur le leadership jeune !",
  },
} as const;
